<div class="analise-centro-custos-container">
  <div class="header d-flex justify-content-between align-items-center flex-wrap gap-2">
    <h1>Análise dos Centros de Custos</h1>
    <div class="d-flex align-items-center acoes-header">
      <button class="btn btn-outline-primary btn-sm" (click)="alterarAno(-1)">
        <i class="fa fa-chevron-left"></i>
      </button>
      <span class="ano-pill">{{ ano }}</span>
      <button class="btn btn-outline-primary btn-sm" (click)="alterarAno(1)">
        <i class="fa fa-chevron-right"></i>
      </button>
      <button class="btn btn-primary btn-sm" (click)="carregarRelatorio()">
        <i class="fa fa-refresh"></i> Atualizar
      </button>
      <button class="btn btn-success btn-sm btn-exportar-excel" (click)="exportarExcel()">
        <i class="fa fa-file-excel-o"></i> Exportar Excel
      </button>
    </div>
  </div>

  <div class="totais-ano mb-3">
    <div class="total-card credito">
      <span>Total Créditos {{ ano }}</span>
      <strong>{{ formatMoney(totalAnoCreditos) }}</strong>
    </div>
    <div class="total-card debito">
      <span>Total Débitos {{ ano }}</span>
      <strong>{{ formatMoney(totalAnoDebitos) }}</strong>
    </div>
    <div class="total-card saldo" [class.negativo]="saldoAno < 0">
      <span>Saldo {{ ano }}</span>
      <strong>{{ formatMoney(saldoAno) }}</strong>
    </div>
  </div>

  <div
    #tabelaScroll
    class="card-box table-responsive"
    [class.dragging-table]="arrastandoTabela"
    (mousedown)="iniciarArrasteTabela($event, tabelaScroll)"
    (mousemove)="moverArrasteTabela($event, tabelaScroll)"
    (mouseup)="encerrarArrasteTabela()"
    (mouseleave)="encerrarArrasteTabela()">
    <table class="table table-bordered table-sm analise-table">
      <thead>
        <tr>
          <th class="sticky-col" rowspan="2">Código</th>
          <th class="sticky-col-2" rowspan="2">Centro de Custos</th>
          <th *ngFor="let mes of meses" colspan="2">{{ mes }}</th>
        </tr>
        <tr>
          <ng-container *ngFor="let mes of meses">
            <th>Créditos</th>
            <th>Débitos</th>
          </ng-container>
        </tr>
      </thead>
      <tbody>
        <tr class="linha-total">
          <td class="sticky-col"></td>
          <td class="sticky-col-2">Totais</td>
          <ng-container *ngFor="let item of totaisCreditos; let i = index">
            <td>{{ formatMoney(item) }}</td>
            <td>{{ formatMoney(totaisDebitos[i]) }}</td>
          </ng-container>
        </tr>

        <tr *ngFor="let item of linhas">
          <td class="sticky-col">{{ item.codigo }}</td>
          <td class="sticky-col-2">{{ item.centroCusto }}</td>
          <ng-container *ngFor="let credito of item.creditos; let i = index">
            <td>{{ formatMoney(credito) }}</td>
            <td>{{ formatMoney(item.debitos[i]) }}</td>
          </ng-container>
        </tr>
      </tbody>
    </table>
  </div>
</div>
